import { OS } from '@ezugi/constants';

import { DeviceInfo } from './deviceInfo';

export const getDevice = () => (DeviceInfo.isIOS && OS.IOS) || (DeviceInfo.isAndroid && OS.ANDROID) || OS.PC;
